let currentSummary = null;
let mutationRevision = 0;

function normalizeSummary(value) {
    if (!value || typeof value !== 'object') return null;
    const count = Number(value.count);
    const subtotal = Number(value.subtotal_without_gift_cards);
    if (!Number.isFinite(count) || !Number.isFinite(subtotal)) return null;
    return {
        count: Math.max(0, Math.trunc(count)),
        subtotalWithoutGiftCards: Math.max(0, subtotal),
        formattedSubtotal:
            typeof value.formatted_subtotal === 'string' ? value.formatted_subtotal : null,
        freeShipping: value.free_shipping === true,
    };
}

function showCartTotal(summary) {
    const currency = document.body.dataset.currency || 'EUR';
    const formattedSubtotal =
        summary.formattedSubtotal ||
        new Intl.NumberFormat('de-AT', {
            style: 'currency',
            currency,
        }).format(summary.subtotalWithoutGiftCards);
    document.querySelectorAll('[data-cart-total]').forEach((badge) => {
        badge.textContent = formattedSubtotal;
        badge.hidden = summary.count < 1;
        const mobileCart = badge.closest('.z-site-header__mobile-cart');
        if (mobileCart) {
            badge.setAttribute('aria-hidden', 'true');
            mobileCart.setAttribute(
                'aria-label',
                summary.count > 0
                    ? `Warenkorb öffnen, Warenkorbwert ${formattedSubtotal}`
                    : 'Warenkorb öffnen',
            );
        } else {
            if (summary.count > 0) {
                badge.removeAttribute('aria-hidden');
                badge.setAttribute('aria-label', `Warenkorbwert ${formattedSubtotal}`);
            } else {
                badge.removeAttribute('aria-label');
            }
        }
    });
}

function applySummary(value) {
    const summary = normalizeSummary(value);
    if (!summary) return false;
    currentSummary = summary;
    showCartTotal(summary);
    document.dispatchEvent(new CustomEvent('zirbelino:cart-state', { detail: summary }));
    return true;
}

function renderedSummary() {
    const header = document.querySelector('[data-site-header][data-cart-summary-count]');
    if (!header) return null;
    return {
        count: header.dataset.cartSummaryCount,
        subtotal_without_gift_cards: header.dataset.cartSummarySubtotal,
        formatted_subtotal: header.dataset.cartSummaryFormattedSubtotal,
        free_shipping: header.dataset.cartSummaryFreeShipping === 'true',
    };
}

export function getCartSummary() {
    return currentSummary;
}

async function refreshCartSummary() {
    const revision = mutationRevision;
    try {
        const response = await fetch('/index.php?route=common/home/get-customer-data', {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
        });
        if (!response.ok) return;
        const state = await response.json();
        if (revision === mutationRevision && state.success) applySummary(state.cartSummary);
    } catch {
        // The public shell and normal cart link remain usable without this enhancement.
    }
}

export function initCartState() {
    if (!document.querySelector('[data-cart-total]')) return;

    const applyInitialState = () => {
        if (mutationRevision === 0) {
            applySummary(window.shopInitialState?.cartSummary || renderedSummary());
        }
    };
    applyInitialState();
    window.addEventListener('shop:initialized', applyInitialState);

    if (window.siteIntegrationsConfig?.privateInitialization) {
        Promise.resolve(window.shopInitialization).then(() => {
            if (!currentSummary) void refreshCartSummary();
        });
    }

    ['zirbelino:cart:add', 'zirbelino:cart-updated', 'zirbelino:cart:change'].forEach((name) => {
        document.addEventListener(name, (event) => {
            mutationRevision++;
            if (!applySummary(event.detail?.cart_summary)) void refreshCartSummary();
        });
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) void refreshCartSummary();
    });
}
